/* eslint-disable @typescript-eslint/naming-convention */

export enum flowOMMEnums {
  OBJECTIVE = 1,
  SCENARIO_CONDITION = 2,
  MIL_CONDITION = 3,
  EXERCISE_CONTROL_CONDITION = 10,
  TRAINING_AUDIENCE_CONDITION = 11,
  CIS_CONDITION = 12,
  SIMULATION_CONDITION = 13,
  OBSERVER_TRAINER_CONDITION = 24,
  BATTLE_RHYTHM_CONDITION = 25,
}

// Below are the enums for the FMM
export enum flowEnums {
  INJECTION = 4,
  ACTION = 5,
  OUTCOME = 6,
  OBSERVATION = 7,
}
export enum flowLILLEnums {
  LILL_CONDITION = 14,
}
export enum flowRLSMEnums {
  CONFIGURATION_CHANGE_REQUEST = 8,
  TROUBLE_TICKET = 9,
  TECHNICAL_SUPPORT_REQUEST = 15,
}

export enum flowPPMEnums {
  PROJECT_INPUT = 16,
  KANBAN = 17,
  DELIVERABLE = 18,
  TEST = 19,
}

export enum flowODC2MEnums {
  PLAN_ORDER_REPORT_PROCESS = 20,
  DECISIVE_CONDITION = 21,
  TASK = 22,
  EFFECT = 23,
}
